import React from 'react';
type SectionProps = {
  id?: string;
  background: 'paper' | 'white' | 'forest';
  children: React.ReactNode;
  className?: string;
  labelledBy?: string;
  width?: 'content' | 'narrow';
};
const backgrounds = {
  paper: 'bg-paper text-ink',
  white: 'bg-white text-ink',
  forest: 'bg-forest text-white'
};
export function Section({
  id,
  background,
  children,
  className = '',
  labelledBy,
  width = 'content'
}: SectionProps) {
  return <section id={id} aria-labelledby={labelledBy} className={`w-full ${backgrounds[background]} ${className}`} data-id="element-273" data-mp="chrj8wg17zxa">
      <div className={`mx-auto px-5 py-14 sm:px-8 sm:py-24 lg:py-32 ${width === 'narrow' ? 'max-w-[720px]' : 'max-w-content'}`} data-id="element-274" data-mp="2qdf2bd4ybxt">
        {children}
      </div>
    </section>;
}
export function Kicker({
  children,
  tone = 'brass',
  className = ''
}: {
  children: React.ReactNode;
  tone?: 'brass' | 'sage';
  className?: string;
}) {
  return <p className={`font-sans text-[11px] font-semibold uppercase tracking-[0.14em] sm:text-[12px] ${tone === 'brass' ? 'text-brass' : 'text-sage'} ${className}`} data-id="element-275" data-mp="2zkbzjpwr41qy">
      {children}
    </p>;
}
export function BrassRule() {
  return <div className="brass-rule mx-auto w-full max-w-content" role="presentation" data-id="element-276" data-mp="38egno1ki2z2s" />;
}